import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LoaderWithText } from '../../../../components/loader/LoaderWithText';
import styles from './search_pagination_loader.module.scss';

export const SearchPaginationLoader: FC = () => (
  <div className={styles.loading}>
    <LoaderWithText>
      <FormattedMessage id="search/SearchPaginationLoader.tsx/1" />
    </LoaderWithText>
  </div>
);
